import { JSX } from "react";

interface WaffleCountBadgeProps {
  backgroundColor: string,
  count: number,
  textColor: string
}

const WaffleCountBadge = (props: WaffleCountBadgeProps): JSX.Element => {

  return (
    <div style={{ backgroundColor: props.backgroundColor, borderRadius: '50%', color: props.textColor, display: 'inline-block', padding: '5px 10px'}}>
      {props.count}
    </div>
  );
  
};

export default WaffleCountBadge;
